<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.nombre" :label="$t('cobrox.canalCobro.labels.nombre')" icon="wifi_channel"/>
                 <show-field :value="item.visiblePorAgencia" :label="$t('cobrox.canalCobro.labels.visiblePorAgencia')" icon="visibility"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.cuentaDestinoDefault.nombre" :label="$t('cobrox.canalCobro.labels.cuentaDestinoDefault')" icon="account_balance"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.tipoCanal" :label="$t('cobrox.canalCobro.labels.tipoCanal')" icon="list"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
     
    
    export default {
        name: 'CanalCobroShowData',
        components: {ShowField},
        
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

